import { render, staticRenderFns } from "./r-owners-panel.vue?vue&type=template&id=3fba7a6a"
import script from "./r-owners-panel.vue?vue&type=script&lang=js"
export * from "./r-owners-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fba7a6a')) {
      api.createRecord('3fba7a6a', component.options)
    } else {
      api.reload('3fba7a6a', component.options)
    }
    module.hot.accept("./r-owners-panel.vue?vue&type=template&id=3fba7a6a", function () {
      api.rerender('3fba7a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/utils/r-owners-panel.vue"
export default component.exports